/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Bz2DClientAsyncResponse } from './bz2DClientAsyncResponse';
import { PosesAndTimes } from './posesAndTimes';


export interface Bz2DClientAsyncStatus {
    asyncResponse?: Bz2DClientAsyncResponse;
    posesAndTimes?: PosesAndTimes;
}

